<template>
  <div class="item-sell" @click="goDetail" v-if="itemInfo">
    <div class="img" v-lazy:background-image="$processImage(img, { resize: 'mid' })"></div>
    <div class="detail">
      <div class="name">
        <span>
          <font-icon :id="icon" :key="icon" v-for="icon in itemInfo.titleIcon"></font-icon>
        </span>
        {{ itemInfo.title }}
      </div>
      <div class="subtitle">{{ itemInfo.subTitle }}</div>
      <div class="room">
        <span v-if="itemInfo.houseTypeArray[0]">{{ itemInfo.houseTypeArray[0] }} Beds</span>
        <span v-if="itemInfo.houseTypeArray[1]">{{ itemInfo.houseTypeArray[1] }} Baths</span>
        <span class="capitalize">{{ $t('houseType.' + itemInfo.propertyType) }}</span>
        <span class="capitalize" v-if="itemInfo.sqft">{{ itemInfo.sqft }} Sq.Ft</span>
      </div>
      <div class="addr">{{ itemInfo.address }}</div>
    </div>
    <div class="price">
      <span>{{ itemInfo.currency | currencySymbol }}{{ $formatMoney(itemInfo.price) }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: Object,
    img: { type: String, default: '' },
  },
  data() {
    return {
      itemInfo: this.info,
    }
  },
  filters: {
    currencySymbol(name) {
      const map = {
        USD: '$',
        RMB: '￥',
      }
      return map[name] || name
    },
  },
  methods: {
    goDetail() {
      window.open(`/sell/detail/${this.itemInfo.uniqueTitle}`)
    },
    getPrice(item) {
      if (item.price) {
        return item.price
      }
      return 0
    },
    getPriceCurrency(item) {
      if (item.currency) {
        if (item.currency === 'RMB') {
          return {
            decimal: ',',
            thousands: ',',
            prefix: '￥ ',
            precision: 0,
            masked: false,
          }
        }
      }
      return {
        decimal: ',',
        thousands: ',',
        prefix: '$ ',
        precision: 0,
        masked: false,
      }
    },
  },
  watch: {
    info(val) {
      return val || {}
    },
  },
}
</script>
<style lang="less" scoped>
.item-sell {
  height: 220px;
  width: 100%;
  border-radius: 10px;
  background-color: #fff;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease-in;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.08);
  margin-bottom: 36px;
  display: flex;
  justify-content: space-between;

  &:hover {
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.16);
  }

  .img {
    height: 100%;
    width: 360px;
    flex: 0 0 360px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .detail {
    margin: 0 30px;
    flex: 1 1 auto;
  }

  .price {
    color: #99d20d;
    font-size: 18px;
    font-weight: 700;
    flex: 0 0 120px;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .name {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 16px;

    .iconfont {
      color: #99d20d;
    }
  }

  .addr {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 16px;
  }

  .subtitle {
    margin: 10px 0;
  }

  .room {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 18px;

    > span {
      background: rgba(0, 0, 0, 0.08);
      margin-right: 10px;
      display: inline-block;
      padding: 4px 6px;
      border-radius: 6px;
    }
  }
}
</style>
